export enum LocalizationRequestPendingEnum {
  getDefaultLanguageTranslationsPending = 'getDefaultLanguageTranslationsPending'
}

export type LocalizationRequestPendingsType = {
  [key in LocalizationRequestPendingEnum]: boolean;
}
